import { useState, useEffect } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    const handleOffline = () => { setOnline(false); };
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (online && !showReconnected) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] text-center py-1.5 px-4 text-xs font-medium transition-all animate-in fade-in slide-in-from-top-1"
      style={{
        background: online ? "#059669" : "#D97706",
        color: online ? "#fff" : "#1c1917",
      }}
      data-testid="offline-indicator">
      <div className="flex items-center justify-center gap-2">
        {online ? <Wifi className="h-3.5 w-3.5" /> : <WifiOff className="h-3.5 w-3.5" />}
        {online ? "Back online" : "You're offline. Some features may be limited."}
      </div>
    </div>
  );
}
